import SharedForm from './SharedForm';
import {
  BarberSharedFormContainer,
  ShopSharedFormContainer,
  BrandSharedFormContainer,
} from './SharedFormContainer';

export const BarberSharedForm = BarberSharedFormContainer(SharedForm);
export const ShopSharedForm = ShopSharedFormContainer(SharedForm);
export const BrandSharedForm = BrandSharedFormContainer(SharedForm);
